import { render, staticRenderFns } from "./CartPlainGoldCustom.vue?vue&type=template&id=56791ba6&scoped=true"
import script from "./CartPlainGoldCustom.vue?vue&type=script&lang=js"
export * from "./CartPlainGoldCustom.vue?vue&type=script&lang=js"
import style0 from "./CartPlainGoldCustom.vue?vue&type=style&index=0&id=56791ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56791ba6",
  null
  
)

export default component.exports